module.exports = __webpack_public_path__ + "static/media/magnifier.0a6b0345.svg";